import type { AppProps } from 'next/app';
import Head from 'next/head';
import { ChakraProvider } from '@chakra-ui/react';
import { ThemeProvider } from 'next-themes';
import { AuthProvider } from '../src/contexts/AuthContext';
import { TicketProvider } from '../src/contexts/TicketContext';
import { StoreProvider } from '../src/contexts/StoreContext';
import { NoticeProvider } from '../src/contexts/NoticeContext';
import { OnboardingProgressProvider } from '../src/contexts/OnboardingProgressContext';
import { ConfirmProvider } from '../src/components/common/ConfirmProvider';
import { UnsavedChangesGuard } from '../src/components/common/UnsavedChanges';
import { ContextReloadNotice } from '../src/components/common/ContextReloadNotice';
import '../styles/globals.css';

export default function App({ Component, pageProps }: AppProps) {
  return (
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false}>
      <Head>
        {/*
          viewport-fit=cover: ノッチ/ホームインジケータの safe-area-inset を有効化。
          user-scalable は指定せず、ピンチ拡大はアクセシビリティのため残す
          （ダブルタップ拡大は globals.css の touch-action: manipulation で抑止）。
        */}
        <meta
          key="viewport"
          name="viewport"
          content="width=device-width, initial-scale=1, viewport-fit=cover"
        />
      </Head>
      <ChakraProvider>
        {/* 確認ダイアログ（UX 監査 A-13） */}
        <ConfirmProvider>
        {/* 未保存の変更があるまま別のページへ移る・閉じるときの確認（UX 監査 A-4） */}
        <UnsavedChangesGuard />
        {/* 会社・店の食い違いで読み直したときの理由（読み直した後に 1 回だけ出す。2026-10-17） */}
        <ContextReloadNotice />
        <AuthProvider>
          <StoreProvider>
            <TicketProvider>
              <NoticeProvider>
                <OnboardingProgressProvider>
                  <Component {...pageProps} />
                </OnboardingProgressProvider>
              </NoticeProvider>
            </TicketProvider>
          </StoreProvider>
        </AuthProvider>
        </ConfirmProvider>
      </ChakraProvider>
    </ThemeProvider>
  );
}
